import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import DonateNow from "./Pages/DonateNow";
import Programs from "./Pages/Programs";
import Volunteer from "./Pages/Volunteer";
import Beneficiaries from "./Pages/Beneficiaries";
import DonorsList from "./Pages/DonorsList";
import Gallery from "./Pages/Gallery";
import Home from "./Pages/Home";
import Header from "./compound/Header";
import Footer from "./compound/Footer";

import ReportIssue from "./Pages/ReportIssue";
import TermsOfService from "./Pages/TermsOfService";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import AdminPrograms from "./Pages/AdminPrograms";






function App() {
  return (
    <Router>
      <Header />
    

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<AboutUs />} />
         <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/DonateNow" element={<DonateNow />} />
           <Route path="/Programs" element={<Programs />} />
            <Route path="/Volunteer" element={<Volunteer />} />
            <Route path="/Beneficiaries" element={<Beneficiaries />} />
            <Route path="/DonorsList" element={<DonorsList />} />
            <Route path="/ReportIssue" element={<ReportIssue />} />
              <Route path="/Gallery" element={<Gallery />} />
            <Route path="/TermsOfService" element={<TermsOfService />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
             <Route path="/AdminPrograms" element={<AdminPrograms />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;